<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="pt-3 pb-0 text-right" >
          <b-button v-if="saveNeeded" variant="warning" class="btn-pill font-lg" style="color: white" @click="onCancel">
            Abbrechen
          </b-button>
          <b-button v-if="saveNeeded" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="onSave">
            Speichern
          </b-button>
          <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
            &nbsp;Zurück
          </b-button>

        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-sheet
              color="white"
              elevation="1"
              class="m-2"
          >
            <v-row>
              <v-col>
                <v-card-title>Überstundenzuschlagsberechnung</v-card-title>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pl-8">
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Einstellung pro Mitarbeitergruppe ?</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob Einstellungen pro Mitarbeitergruppe getroffen werden oder ob die Einstellungen für alle Mitarbeiter gelten.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="trueFalseSelects"
                        v-model="use_diff_ueb_settings"
                        @input="saveNeeded = true; currentMigr = use_diff_ueb_settings ? migrs[0] : null"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="use_diff_ueb_settings">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Mitarbeitergruppe:</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="migrs"
                        v-model="currentMigr"
                        item-text="name"
                        item-value="access"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Art der Berechnung</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an wie/ob Überstundenzuschläge berechnet werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="uebTypeSelects"
                        v-model="!use_diff_ueb_settings ? ueb_settings_all.ueb_surcharge_type : migr_ueb_settings[currentMigr].ueb_surcharge_type"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider vertical/>
              <v-col style="padding-right: 22px">

              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

      </v-row>
    </div>
  </v-main>
</template>


<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy";

export default {
  name: "UebSettings",
  data: () => ({
    // controls
    saveNeeded: false,
    loader: undefined,
    salary_surcharges: [{id: "", name: ""}],
    time_surcharges: [{id: "", name: ""}],
    overtimes: [{id: "", name: ""}],
    absences: [{id: "", name: ""}],
    employment_types: ["name"],
    migrs: [{name: "", access: ""}],
    currentMigr: null,
    ueb_settings_all: {
      ueb_surcharge_type: "1",
      calc_weekly_saldo: false,
      weekly_sum_type: "fixed",
      fixed_sum: "",
      use_korridor: false,
      time_frame: "",
    },
    migr_ueb_settings: [],
    ueb_lohn_setting: {},
    ueb_geleistet_settings: [],
    ueb_abgefeiert: {},
    use_diff_ueb_settings: false,


    trueFalseSelects: [{text: "Ja", value: true}, {text: "Nein", value: false}],
    uebTypeSelects: [
        {text: "Keine Berechnung", value: "0"},
      {text: "Tägliche Sollzeit", value: "1"},
      {text: "Standard Arbeitszeit ", value: "2"},
      {text: "Wöchentliche Arbeitszeit ", value: "3"},
      {text: "Täglicher Rahmen ", value: "4"},
    ],
  }),
  computed: {
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/ueb_setting'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      this.saveNeeded = false;
      if (response.status === 200) {
        let res = response.body;

      } else {
        //window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    onBack() {
      window.history.back();
    },
    onSave() {
    },
    onCancel() {
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/ueb_setting'
      ).then(this.responseOkGet, this.responseError)
    },
  }
}
</script>

<style scoped>
.v-input::v-deep .v-label {
  margin-bottom: 0;
}

.rb-ellipsis::v-deep > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}



</style>
